import React, { useEffect, useLayoutEffect, useState } from "react";

import Card from "react-bootstrap/Card";
import Spinner from "react-bootstrap/Spinner";
import { faSquareCheck, faShare , faRightFromBracket, faCircleRight, faClock, faSeedling } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AxiosService from "../../Utils/AxiosService";

import { toast } from "react-toastify";

import TableView from "../TableView/TableView";
import LocalStorageService from "../../Auth/auth_service/AuthServiceStorage";
import Reactselect from "../../Components/Reactselect";
import { Button, Modal } from "react-bootstrap";
import "../TableView/Table.css";
import { LanguageProvider } from "../../context/LanguageContext";


const LabelView = () => {
  const apiService = new AxiosService();
  const authDetails = LocalStorageService.getAuthDetails();

  const [allLabelsPending, setAllLabelsPending] = useState([]);
  const [allLabelsComp, setAllLabelsComp] = useState([]);
  const [allLabelsAssign, setAllLabelsAssign] = useState([]);
  const [allLabelsFreshPending, setAllLabelsFreshPending] = useState([]);

  const [labelPendingLoader, setLabelPendingLoader] = useState(false);
  const [labelCompLoader, setLabelCompLoader] = useState(false);
  const [labelFreshPendingLoader, setLabelFreshPendingLoader] = useState(false);

  const [labelAssignLoader, setLabelAssignLoader] = useState(false);

  const [selectedLabel, setSelectedLabel] = useState("");

  const [selPendingLabel, setSelPendingLabel] = useState("");
  const [selCompLabel, setSelCompLabel] = useState("");
  const [selAssignLabel, setSelAssignLabel] = useState("");
  const [selFreshPendingLabel, setSelFreshPendingLabel] = useState("");

  const [data, setData] = useState({});
  const [relatesToData, setRelatesToData] = useState({});
  const [loader, setLoader] = useState(false);

  const [completeLoader, setCompleteLoader] = useState(false);
  const [assignLoader, setAssignLoader] = useState(false);
  const [assignBackLoader, setAssignBackLoader] = useState(false);
  const [show, setShow] = useState(false);
  const [assignShow, setAssignShow] = useState(false);
  const [assignBackShow, setAssignBackShow] = useState(false);
  const [pendinBackShow, setPendingBackShow] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(
    () => sessionStorage.getItem("selectedLanguage") || ""
  );
  const [isNewLabel , setIsNewLabel] = useState(false);
  const [newLabel , setNewLabel] = useState("");
  const [pendingLoader, setPendingLoader] = useState(false);
  const [pendingShow, setPendingShow] = useState(false);
   const [languages, setLanguages] = useState(null);
   const [loading, setLoading] = useState(false);

  const [editFlag , setEditFlag] = useState(false);
  const [dynamicLabelConfig, setdynamicLabelConfig] = useState(
    {
      newLabel: "",
      pendingLabel: "",
      reassignedLabel: "",
      completedLabel: "",
      moveBtn:"",
      completeBtn:"",
      assignBackBtn:"",
      pendingBtn:"",
      reAssignBtn:""
    })

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleAssignModelClose = () => setAssignShow(false);
  const handleAssignModelShow = () => setAssignShow(true);

  const handleAssignBackModelClose = () => setAssignBackShow(false);
  const handleAssignBackModelShow = () => setAssignBackShow(true);
  
  
  const handlePendingBackModelClose = () => setPendingBackShow(false);
  const handlePendingBackModelShow = () => setPendingBackShow(true);

  const handlePendingModelClose = () => setPendingShow(false);
  const handlePendingModelShow = () => setPendingShow(true);

  const refreshAllLabels = () => {
    if (!authDetails) return;
    getAllLabelsPending();
    getAllLabelsComp();
    getAllLabelsAssigned();
    getAllLabelsFreshPending();
  };

  const getAllLabelsPending = () => {

    setLabelPendingLoader(true);

    const auth_details = JSON.parse(authDetails);

    apiService
      .getAllLabels(auth_details.roles, "N", selectedLanguage,auth_details.id)
      .then((response) => {
        setLabelPendingLoader(false);
        if (response.data) {
          setAllLabelsPending(response.data);
        }
      })
      .catch((error) => {
        setLabelPendingLoader(false);

        if (error?.response?.data?.message) {
          toast.error(error.response.data.message);
        } else {
          toast.error("Something went wrong!");
        }
      });
  };

  const getAllLabelsFreshPending = () => {

    setLabelFreshPendingLoader(true);

    const auth_details = JSON.parse(authDetails);

    apiService
      .getAllLabels(auth_details.roles, "F", selectedLanguage,auth_details.id)
      .then((response) => {
        setLabelFreshPendingLoader(false);
        if (response.data) {
          setAllLabelsFreshPending(response.data);
        }
      })
      .catch((error) => {
        setLabelFreshPendingLoader(false);

        if (error?.response?.data?.message) {
          toast.error(error.response.data.message);
        } else {
          toast.error("Something went wrong!");
        }
      });
  };

  const getAllLabelsComp = () => {
    setLabelCompLoader(true);

    const auth_details = JSON.parse(authDetails);

    apiService
      .getAllLabels(auth_details.roles, "Y",selectedLanguage,auth_details.id)
      .then((response) => {
        setLabelCompLoader(false);
        if (response.data) {
          setAllLabelsComp(response.data);
        }
      })
      .catch((error) => {
        setLabelCompLoader(false);

        if (error?.response?.data?.message) {
          toast.error(error.response.data.message);
        } else {
          toast.error("Something went wrong!");
        }
      });
  };

  const getDynamicLabelConfig = () => {
    setLabelCompLoader(true);
    const language=sessionStorage.getItem('selectedLanguage')
    const auth_details = JSON.parse(authDetails);
    const finalRole=(language && language!=="")? [language]:auth_details.roles;

    apiService
      .getDynamicLabelConfig(finalRole)
      .then((response) => {
        setLabelCompLoader(false);
        if (response.data) {
          setdynamicLabelConfig({
            newLabel: response.data.newLabel,
            pendingLabel: response.data.pendingLabel,
            reassignedLabel: response.data.reassignedLabel,
            completedLabel: response.data.completedLabel,
            moveBtn:response.data.moveBtn,
            reAssignBtn:response.data.reAssignBtn,
            completeBtn:response.data.completeBtn,
            assignBackBtn:response.data.assignBackBtn,
            pendingBtn:response.data.pendingBtn,
          });
        }
      })
      .catch((error) => {
        setLabelCompLoader(false);

        if (error?.response?.data?.message) {
          toast.error(error.response.data.message);
        } else {
          toast.error("Something went wrong!");
        }
      });
  };


  const getLabelData = () => {
    setLoader(true);

    apiService
      .getLabelData(selectedLabel)
      .then((response) => {
        setLoader(false);
        if (response.data) {
          console.log(response.data)
          setData(response.data);
          LocalStorageService.setSelectedLabelId(selectedLabel);
          const sessionStorageUpdatedEvent = new Event('sessionStorageLabelUpdated');
          window.dispatchEvent(sessionStorageUpdatedEvent);
          getRelatesToData(selectedLabel);
        }
      })
      .catch((error) => {
        setLoader(false);

        if (error?.response?.data?.message) {
          toast.error(error.response.data.message);
        } else {
          toast.error("Something went wrong!");
        }
      });
  };

    const getRelatesToData = () => {
    setLoader(true);

    apiService
      .getLabelRelatesToDetails(selectedLabel)
      .then((response) => {
        setLoader(false);
        if (response.data) {
          console.log(response.data)
          setRelatesToData(response.data);
        }
      })
      .catch((error) => {
        setLoader(false);

        if (error?.response?.data?.message) {
          toast.error(error.response.data.message);
        } else {
          toast.error("Something went wrong!");
        }
      });
  };

  const onCompleteLabel = () => {
    setCompleteLoader(true);

    const auth_details = JSON.parse(authDetails);


    apiService
      .labelStatusUpdate(selectedLabel, "Y",auth_details.id)
      .then((response) => {
        setCompleteLoader(false);
        setShow(false);

        refreshAllLabels();

        setData({});
        setSelectedLabel("");
        setSelPendingLabel("");
        setSelCompLabel("");
        setSelAssignLabel("");
        setSelFreshPendingLabel("");
        setEditFlag(false)

        toast.success("Label updated successfully!");
      })
      .catch((error) => {
        setCompleteLoader(false);

        if (error?.response?.data?.message) {
          toast.error(error.response.data.message);
        } else {
          toast.error("Something went wrong!");
        }
      });
  };

  useEffect(() => {
    if (selectedLabel) {
      setData({});
      validationAlertForLabel(selectedLabel);
      fetchLanguages();
    }
  }, [selectedLabel]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const getAllLabelsAssigned = () => {
    setLabelAssignLoader(true);

    const auth_details = JSON.parse(authDetails);

    apiService
      .getAllLabels(auth_details.roles, "R",selectedLanguage,auth_details.id)
      .then((response) => {
        setLabelAssignLoader(false);
        if (response.data) {
          setAllLabelsAssign(response.data);
        }
      })
      .catch((error) => {
        setLabelAssignLoader(false);

        if (error?.response?.data?.message) {
          toast.error(error.response.data.message);
        } else {
          toast.error("Something went wrong!");
        }
      });
  };

  const onAssignLabel = () => {
    setAssignLoader(true);

    const auth_details = JSON.parse(authDetails);
    apiService
      .labelStatusUpdate(selectedLabel, "R",auth_details.id)
      .then((response) => {
        setAssignLoader(false);
        setAssignShow(false);

        refreshAllLabels();

        setData({});
        setSelectedLabel("");
        setSelPendingLabel("");
        setSelCompLabel("");
        setSelAssignLabel("");
        setSelFreshPendingLabel("");
        setEditFlag(false);

        toast.success("Label updated successfully!");
      })
      .catch((error) => {
        setAssignShow(false);
        setAssignLoader(false);

        if (error?.response?.data?.message) {
          toast.error(error.response.data.message);
        } else {
          toast.error("Something went wrong!");
        }
      });
  };

  const onAssignBackLabel = () => {
    setAssignBackLoader(true);

    const auth_details = JSON.parse(authDetails);
    apiService
      .labelStatusUpdate(selectedLabel, "N",auth_details.id)
      .then((response) => {
        setAssignBackLoader(false);
        setAssignBackShow(false);

        refreshAllLabels();

        setData({});
        setSelectedLabel("");
        setSelPendingLabel("");
        setSelCompLabel("");
        setSelAssignLabel("");
        setSelFreshPendingLabel("");
        setEditFlag(false);

        toast.success("Label updated successfully!");
      })
      .catch((error) => {
        setAssignBackLoader(false);

        if (error?.response?.data?.message) {
          toast.error(error.response.data.message);
        } else {
          toast.error("Something went wrong!");
        }
      });
  };

  // useEffect(() => {
  //  setSelectedLanguage(LocalStorageService.getSelectedLanguage())
  // }, [LocalStorageService.getSelectedLanguage()]);

  useEffect(() => {
    refreshAllLabels();
    setData({});
    setSelectedLabel("");
    setSelPendingLabel("");
    setSelCompLabel("");
    setSelAssignLabel("");
    setSelFreshPendingLabel("");
    sessionStorage.removeItem("selectedLabelId");
    setEditFlag(false);
    getDynamicLabelConfig();
   }, [selectedLanguage]);

  
  useEffect(() => {
    const handleSessionStorageUpdate = () => {
      setSelectedLanguage(sessionStorage.getItem('selectedLanguage'));
    };

    window.addEventListener('sessionStorageUpdated', handleSessionStorageUpdate);

    return () => {
      window.removeEventListener('sessionStorageUpdated', handleSessionStorageUpdate);
    };
  }, []);

  const onPeningBackLabel = () => {
    setCompleteLoader(true);

    const auth_details = JSON.parse(authDetails);
    apiService
      .labelStatusUpdate(selectedLabel, "N",auth_details.id)
      .then((response) => {
        setCompleteLoader(false);
        setPendingBackShow(false);

        refreshAllLabels();

        setData({});
        setSelectedLabel("");
        setSelPendingLabel("");
        setSelCompLabel("");
        setSelAssignLabel("");
        setSelFreshPendingLabel("");

        toast.success("Label updated successfully!");
      })
      .catch((error) => {
        setAssignBackLoader(false);

        if (error?.response?.data?.message) {
          toast.error(error.response.data.message);
        } else {
          toast.error("Something went wrong!");
        }
      });
  };

  const handleDataChange = (newData) => {
    console.log(newData)
    setData(JSON.stringify(newData));
  };

  useEffect(() => {

  },[data]);

  useEffect(() => {
    if (isNewLabel) {
      const auth_details = JSON.parse(authDetails);

      if(auth_details.newLabelViewer){
        setData({});
        setSelectedLabel(newLabel.LABEL_ID);
        setIsNewLabel(false);
      
      }else{
       setData({});
       validationAlertForLabel(newLabel.LABEL_ID , isNewLabel);
      // onNewToPendingLabel();
      }
      
    }
  }, [isNewLabel]);


  const onNewToPendingLabel = () => {
  
    const auth_details = JSON.parse(authDetails);


    apiService
      .labelStatusUpdate(selFreshPendingLabel.LABEL_ID, "N",auth_details.id)
      .then((response) => {
        setShow(false);
        setPendingLoader(false);
        setPendingShow(false);

        refreshAllLabels();

        setData({});
        setSelectedLabel("");
        setSelCompLabel("");
        setSelAssignLabel("");
        setSelFreshPendingLabel("");
        setEditFlag(false)
        setIsNewLabel(false);
        setSelectedLabel("");
        setSelPendingLabel("");


        toast.success("Label updated successfully!");
      })
      .catch((error) => {
        if (error?.response?.data?.message) {
          toast.error(error.response.data.message);
        } else {
          toast.error("Something went wrong!");
        }
      });
  };

  
  // const validationAlertForLabel = async (labelId , isNewLabel) => {
  //   setLoader(true);
  //     await apiService.checkValidationOrCvPresent(labelId).then((response) => {
  //       console.log(response);
  //       setLoader(false);
  //       if (response.data !== "") {
  //         const userConfirmed = window.confirm(response.data);
  //         if (userConfirmed) {
  //           if(!isNewLabel){
  //             getLabelData();
  //           }
  //         }
  //       } else {
  //         if(!isNewLabel){
  //           getLabelData();
  //         }else{
  //           console.log("sddddddddddddddddddddddddddd")
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       setLoader(false);
  //       if (error?.response?.data?.message) {
  //         toast.error(error.response.data.message);
  //       } else {
  //         toast.error("Something went wrong!");
  //       }
  //     });;
  // };

  const validationAlertForLabel = (labelId, isNewLabel) => {
    console.log(isNewLabel,labelId)
  if (!isNewLabel) {
    getLabelData();
  } else {
    console.log(isNewLabel,"New label is Empty");
  }
};

   const fetchLanguages = async () => {
      try {
        setLoading(true);
        const response = await apiService.getLanguageDetails(selectedLabel);
        setLanguages(response.data);
        LocalStorageService.setDefaultLanguage(response.data.defaultLanguage.code);
      } catch (error) {
        console.error("Error fetching languages:", error);
        setLanguages(null);
      } finally {
        setLoading(false);
      }
    };

    const checkLabelStatus=(status)=>{
      LocalStorageService.setSelectedLabelIdStatus(status);
      const sessionStorageUpdatedEvent = new Event('sessionStorageLabelUpdated');
      window.dispatchEvent(sessionStorageUpdatedEvent);
    }

  return (
    <div style={{ marginRight: 35 }}>
      <div className="row  row-cols-1 row-cols-md-3 g-1">
        <div className="col-md-2-custom">
          <Card>
            <Card.Header className=" h5">
              <FontAwesomeIcon
                icon={faSeedling}
                className="text-success me-1"
              />
              {dynamicLabelConfig.newLabel
                ? dynamicLabelConfig.newLabel
                : "New Labels"}
              <span className="text-muted ms-1">
                ({allLabelsFreshPending.length})
              </span>
            </Card.Header>
            <Card.Body>
              <div className="d-flex justify-content-center align-items-start">
                <div className="custom-select-width">
                  <Reactselect
                    options={allLabelsFreshPending}
                    loader={labelFreshPendingLoader}
                    selectedLabel={selFreshPendingLabel}
                    handleChange={(e) => {
                      setSelFreshPendingLabel(e);
                      setSelPendingLabel("");
                      setEditFlag(false);
                      setSelCompLabel("");
                      setSelAssignLabel("");
                      setIsNewLabel(true);
                      setNewLabel(e);
                      checkLabelStatus(null);
                      localStorage.selectedLabel = e.LABEL_ID;
                    }}
                  />
                </div>
                <button
                  disabled={!selFreshPendingLabel || pendingLoader}
                  onClick={handlePendingModelShow}
                  className="btn  btn-success ms-1"
                  title="Move to Pending"
                  style={{ fontSize: "12px" }}
                >
                  {dynamicLabelConfig.moveBtn
                    ? dynamicLabelConfig.moveBtn
                    : "Move"}
                </button>
              </div>
            </Card.Body>
          </Card>
        </div>
        <div className="col-md-4-custom">
          <Card>
            <Card.Header className=" h5">
              <FontAwesomeIcon icon={faClock} className="text-success me-1" />
              {dynamicLabelConfig.pendingLabel
                ? dynamicLabelConfig.pendingLabel
                : "Pending Labels"}

              <span className="text-muted ms-1">
                ({allLabelsPending.length})
              </span>
            </Card.Header>
            <Card.Body>
              <div className="row">
                <div className="col-sm-6">
                  <Reactselect
                    options={allLabelsPending}
                    loader={labelPendingLoader}
                    selectedLabel={selPendingLabel}
                    handleChange={(e) => {
                      setSelPendingLabel(e);
                      setEditFlag(true);
                      setSelCompLabel("");
                      setSelAssignLabel("");
                      setSelFreshPendingLabel("");
                      setSelectedLabel(e.LABEL_ID);
                      checkLabelStatus(null);
                      localStorage.selectedLabel = e.LABEL_ID;
                    }}
                  />
                </div>
                <div className="col-sm">
                  <div className="button-container">
                    <button
                      disabled={!selPendingLabel || assignLoader}
                      onClick={handleAssignModelShow}
                      className="btn btn-secondary customBtn"
                      style={{ fontSize: "12px" }}
                    >
                      <>
                        {dynamicLabelConfig.reAssignBtn
                          ? dynamicLabelConfig.reAssignBtn
                          : "Reassign"}
                      </>
                    </button>
                    <button
                      disabled={!selPendingLabel || completeLoader}
                      onClick={handleShow}
                      className="btn btn-success customBtn"
                      style={{ fontSize: "12px" }}
                    >
                      <>
                        {dynamicLabelConfig.completeBtn
                          ? dynamicLabelConfig.completeBtn
                          : "Complete"}
                      </>
                    </button>
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>

        <div className="col-md-3">
          <Card>
            <Card.Header className=" h5">
              <FontAwesomeIcon icon={faShare} className="text-success me-1" />
              {dynamicLabelConfig.reassignedLabel
                ? dynamicLabelConfig.reassignedLabel
                : "Reassigned Labels"}

              <span className="text-muted ms-1">
                ({allLabelsAssign.length})
              </span>
            </Card.Header>
            <Card.Body>
              <div className="row">
                <div className="col-8">
                  <Reactselect
                    options={allLabelsAssign}
                    loader={labelAssignLoader}
                    selectedLabel={selAssignLabel}
                    handleChange={(e) => {
                      setSelAssignLabel(e);
                      setSelPendingLabel("");
                      setEditFlag(false);
                      setSelCompLabel("");
                      setSelFreshPendingLabel("");
                      setSelectedLabel(e.LABEL_ID);
                      checkLabelStatus('R')
                      localStorage.selectedLabel = e.LABEL_ID;
                    }}
                  />
                </div>
                <div className="col-2">
                  <button
                    disabled={
                      !selAssignLabel ||
                      assignBackLoader ||
                      !JSON.parse(authDetails)?.newLabelViewer
                    }
                    onClick={handleAssignBackModelShow}
                    className="btn  btn-success customBtn"
                    title="Assignback"
                    style={{ fontSize: "12px" }}
                  >
                    {dynamicLabelConfig.assignBackBtn
                      ? dynamicLabelConfig.assignBackBtn
                      : "AssignBack"}
                  </button>
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>

        <div className="col-md-3">
          <Card>
            <Card.Header className=" h5">
              <FontAwesomeIcon
                icon={faSquareCheck}
                className="text-success me-1"
              />
              {dynamicLabelConfig.completedLabel
                ? dynamicLabelConfig.completedLabel
                : "Completed Labels"}
              <span className="text-muted ms-1">({allLabelsComp.length})</span>
            </Card.Header>
            <Card.Body>
              <div className="row">
                <div className="col-8">
                  <Reactselect
                    options={allLabelsComp}
                    loader={labelCompLoader}
                    selectedLabel={selCompLabel}
                    handleChange={(e) => {
                      setSelCompLabel(e);
                      setSelPendingLabel("");
                      setSelAssignLabel("");
                      setSelFreshPendingLabel("");
                      setSelectedLabel(e.LABEL_ID);
                      checkLabelStatus(null);
                      localStorage.selectedLabel = e.LABEL_ID;
                    }}
                  />
                </div>
                <div className="col-2">
                  <button
                    disabled={!selCompLabel || completeLoader}
                    onClick={handlePendingBackModelShow}
                    className="btn btn-success customBtn"
                    title="Move to Pending"
                    style={{ fontSize: "12px" }}
                  >
                    <>
                      {/* <FontAwesomeIcon icon={faArrowRotateLeft}  /> */}
                      {dynamicLabelConfig.pendingBtn
                        ? dynamicLabelConfig.pendingBtn
                        : "Pending"}
                    </>
                  </button>
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>

      {loader && (
        <>
          <Card className="mt-2 ">
            <Card.Body>
              <div className="text-center p-3">
                <Spinner animation="border" />
              </div>
            </Card.Body>
          </Card>
        </>
      )}
      <LanguageProvider languages={languages} loading={loading}>
        {data && data["type"] && (
          <TableView
            jsonData={data}
            label={selectedLabel}
            editFlag={editFlag}
            onDataChange={handleDataChange}
            relatesToData={relatesToData}
          />
        )}
      </LanguageProvider>

      <Modal centered show={show} onHide={handleClose}>
        <Modal.Body>
          Label <strong>{selPendingLabel.LABEL_NO?.split("--")[0]}</strong> will
          be marked as completed, please confirm
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="success"
            disabled={completeLoader}
            onClick={onCompleteLabel}
          >
            {completeLoader ? (
              <>
                <Spinner animation="grow" size="sm" />
                <Spinner animation="grow" size="sm" />
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faSquareCheck} className="me-1" />
                Submit
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal centered show={assignShow} onHide={handleAssignModelClose}>
        <Modal.Body>
          Label <strong>{selPendingLabel.LABEL_NO?.split("--")[0]}</strong> will
          be sent back to MC, please confirm
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleAssignModelClose}>
            Close
          </Button>
          <Button
            variant="success"
            disabled={assignLoader}
            onClick={onAssignLabel}
          >
            {assignLoader ? (
              <>
                <Spinner animation="grow" size="sm" />
                <Spinner animation="grow" size="sm" />
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faSquareCheck} className="me-1" />
                Submit
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal centered show={assignBackShow} onHide={handleAssignBackModelClose}>
        <Modal.Body>
          Label <strong>{selAssignLabel.LABEL_NO?.split("--")[0]}</strong> will
          be assign back to pending, please confirm
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleAssignBackModelClose}>
            Close
          </Button>
          <Button
            variant="success"
            disabled={assignBackLoader}
            onClick={onAssignBackLabel}
          >
            {assignBackLoader ? (
              <>
                <Spinner animation="grow" size="sm" />
                <Spinner animation="grow" size="sm" />
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faSquareCheck} className="me-1" />
                Submit
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        centered
        show={pendinBackShow}
        onHide={handlePendingBackModelClose}
      >
        <Modal.Body>
          Label <strong>{selCompLabel.LABEL_NO?.split("--")[0]}</strong> will be
          assign back to pending, please confirm
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handlePendingBackModelClose}>
            Close
          </Button>
          <Button
            variant="success"
            disabled={completeLoader}
            onClick={onPeningBackLabel}
          >
            {assignBackLoader ? (
              <>
                <Spinner animation="grow" size="sm" />
                <Spinner animation="grow" size="sm" />
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faSquareCheck} className="me-1" />
                Submit
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal centered show={pendingShow} onHide={handlePendingModelClose}>
        <Modal.Body>
          Label <strong>{selFreshPendingLabel.LABEL_NO?.split("--")[0]}</strong>{" "}
          will be move to pending, please confirm
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handlePendingModelClose}>
            Close
          </Button>
          <Button
            variant="success"
            disabled={pendingLoader}
            onClick={onNewToPendingLabel}
          >
            {pendingLoader ? (
              <>
                <Spinner animation="grow" size="sm" />
                <Spinner animation="grow" size="sm" />
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faSquareCheck} className="me-1" />
                Submit
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default LabelView;
